import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Button, Divider, Form, Input, message } from "antd";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "../../Store/authStore";
import { BreadCrumbs } from "../Common/BreadCrumbs";
import StickyHeader from "../Common/StickyHeader";
import { SettingService } from "./SettingService";

export const UpdatePassword = (props) => {
  console.log("UpdatePassword", props);
  const history = useHistory();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [isResetting, setIsResetting] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const header = useMemo(() => {
    return (props.parentBread || []).concat({
      title: "Change Password",
    });
  }, []);
  const onReset = async (values) => {
    try {
      if (isResetting) return;
      setIsResetting(true);
      const { protocol, hostname } = window.location;
      const authUrl = protocol + "//" + hostname;
      const resetRes = await SettingService.resetPassword(
        values.newPassword,
        authUrl
      );
      onLogout();
      setIsResetting(false);
      message.success(`Password Reset Successful`);
    } catch (e) {
      setIsResetting(false);
      message.error("Failed to Reset Password. Please try again!");
    }
  };
  const onLogout = () => {
    dispatch(logout());
    history.push("/login");
  };
  return (
    <div className="entity-list-container">
      <StickyHeader>
        <div className="page-header-container">
          <BreadCrumbs style={{fontSize:"45px"}} headers={header} />
        </div>
        <Divider className="divider" />
      </StickyHeader>
      <div className="reset-form">
        <Form
          form={form}
          name="normal_login"
          initialValues={{
            remember: false,
          }}
          onFinish={onReset}
          requiredMark={false}
          labelCol={{ span: 8 }}
        >
          <div>
            <Form.Item
              name="newPassword"
              label="New Password"
              rules={[
                {
                  required: true,
                  message: "Please enter New Password!",
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={["newPassword"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please enter New Password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      setIsValidPassword(true);
                      return Promise.resolve();
                    } else {
                      setIsValidPassword(false);
                      return Promise.reject(
                        new Error("Passwords do not match!")
                      );
                    }
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8 }}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={!isValidPassword}
                icon={isResetting && <LoadingOutlined />}
              >
                {isResetting ? "Updating" : "Update"}
              </Button>
              <Button
                htmlType="button"
                onClick={() => form.resetFields()}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};
